/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Item Produto" label-for>
            <v-select
              label="desc_dose"
              :options="itens_produtos"
              :reduce="(item) => item.id_item_produto"
              v-model="restricao_estado.id_item_produto"
            >
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Estado" label-for>
            <v-select
              label="nome"
              :options="estados"
              :reduce="(item) => item.id_estado"
              v-model="restricao_estado.id_estado"
            >
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Data de Restrição:" label-for="input-1">
            <b-form-input
              v-model="restricao_estado.data_restricao"
              type="date"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="success" @click.prevent="salvar"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Service from '@src/services/restricoes-estado'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

import estado from '@/src/services/estados-register'
import ItemProduto from '@src/services/itens_produto'

import moment from 'moment'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    restricao_estado: {},
  },
  data() {
    return {
      itens_produtos: [],
      estados: [],
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
    }
  },
  created() {},
  mounted() {
    this.restricao_estado.data_restricao = this.restricao_estado.data_restricao
      ? moment(this.restricao_estado.data_restricao).format('YYYY-MM-DD')
      : ''
    this.handleGet()
  },
  methods: {
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      ItemProduto.listar(token).then((response) => {
        this.itens_produtos = response.data.dados
      })
      estado.listar().then((resposta) => {
        this.estados = resposta.data.dados
      })
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      if (this.restricao_estado.id_restricao_estado) {
        this.isLoading = this.loading(this.isLoading)
        Service.update(token, this.restricao_estado)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Service.salvar(token, this.restricao_estado)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast('Salvo com sucesso!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.restricao_estado = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.$bvToast.toast(
              erro.response
                ? erro.response.data.data.join(', ')
                : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(this.isLoading)
          })
      }
    },
  },
}
</script>

<style>
</style>